import { jsx, jsxs } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M10 20C11.1046 20 12 19.1046 12 18H8C8 19.1046 8.89543 20 10 20Z", fill: "currentColor", fillOpacity: 0.9 }),
  /* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 15L19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10V15H4V17H5H19H20V15H19Z", fill: "currentColor", fillOpacity: 0.9 })
] });
export default SvgBell;
